<script lang="ts">
  import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()

  export let showBack = true
</script>

<nav class="navbar" on:click={() => dispatch('back')}>
  <div class="relative flex items-center h-14">
    <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="chevron-left" class="{showBack ? 'visible' : 'hidden'}" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"></path></svg>
  </div>
</nav>

<style lang="scss">
  .navbar {
    @apply px-3;
    position: sticky;
    background-color: transparent;
    flex: 0 0 56px;
    top: 0;
    left: 0;
    right: 0;
    //box-shadow: rgba(27, 31, 35, 0.04) 0 1px 0, rgba(255, 255, 255, 0.25) 0 1px 0 inset;
  }

  svg {
    width: 24px;
    height: 24px;
  }
</style>
